import { render, staticRenderFns } from "./schedule_individual_competition.vue?vue&type=template&id=0fa65981&scoped=true&"
import script from "./schedule_individual_competition.vue?vue&type=script&lang=js&"
export * from "./schedule_individual_competition.vue?vue&type=script&lang=js&"
import style0 from "./schedule_individual_competition.vue?vue&type=style&index=0&id=0fa65981&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa65981",
  null
  
)

export default component.exports